// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3O-42","amount":"Amount_amount__26vhk","tip":"Amount_tip__3hb2Y","tipHeader":"Amount_tipHeader__30s1j","tipsWrap":"Amount_tipsWrap__2MaDx"};